// Componentes de macamedia
import "./components";

// Utils de macamedia
import "./utils";

//require("./assets/element_correcciones.css");
require("./assets/element_movil.css");
